import { domain } from 'modules/data';
import { memo } from 'react';

import { XeroCisDeductionBill } from '../XeroCisDeductionBill/XeroCisDeductionBill';
import { XeroCisDeductionInvoice } from '../XeroCisDeductionInvoice/XeroCisDeductionInvoice';
import { XeroCisDeductionProps } from './XeroCisDeduction.types';

export const XeroCisDeduction = memo<XeroCisDeductionProps>((props) => {
    const { companyId, details, organizationCisSettings, lineItems, currency } = props;

    if (details.integrationCode === domain.IntegrationCode.XeroBill) {
        if (!organizationCisSettings?.contractorEnabled || !details.contact?.id) {
            return null;
        }

        return (
            <XeroCisDeductionBill
                currency={currency}
                lineAmountType={details.lineAmountType}
                lineItems={lineItems}
                companyId={companyId}
                contactId={details.contact.id}
            />
        );
    }

    if (details.integrationCode === domain.IntegrationCode.XeroInvoice) {
        if (!organizationCisSettings?.subContractorEnabled || typeof organizationCisSettings.companyRate !== 'number') {
            return null;
        }

        return (
            <XeroCisDeductionInvoice
                currency={currency}
                cisRate={organizationCisSettings.companyRate}
                lineAmountType={details.lineAmountType}
                lineItems={lineItems}
            />
        );
    }

    return null;
});

XeroCisDeduction.displayName = 'XeroCisDeduction';
